<app-nav></app-nav>
<div class="parnter-lead">
    <h2>Car Insurance</h2>
    <form name="form" #leadForm="ngForm" (submit)="createProspect()">
        <h3>Contact Details</h3>
        <div class="form-group">
            <input type="text" class="form-control" name="name" #name="ngModel" [(ngModel)]="lead.name" placeholder="Name" required />
            <div *ngIf="name.invalid && name.touched " class="error-message">
                <div *ngIf="name.errors.required">
                    Name is required.
                </div>
            </div>
        </div>
        <div class="form-group">
            <input type="text" class="form-control city-input" [typeahead]="cityList"
                (typeaheadOnSelect)="selectCity($event)" (focusout)="checkCityValue($event)" [isAnimated]="true"
                #city="ngModel" name="city" [(ngModel)]="lead.city" placeholder="City" maxlength="50" required />
            <div *ngIf="city.invalid && city.touched " class="error-message">
                <div *ngIf="city.errors.required && !noResult">
                    City is required.
                </div>
            </div>
            <div *ngIf="noResult" class="error-message">No results found!</div>
        </div>
        <div class="form-group">
            <input type="text" class="form-control" name="mobile" #mobile="ngModel" [(ngModel)]="lead.mobile" placeholder="Mobile No." required />
            <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
                <div *ngIf="mobile.errors.required">
                    Mobile is required.
                </div>
            </div>
        </div>
        <div class="form-group">
            <input type="text" class="form-control" name="email" #email="ngModel" [email]="true" [(ngModel)]="lead.email" placeholder="Email" required />
            <div *ngIf="email.invalid && email.touched" class="error-message">
                <div *ngIf="email.errors.required">
                  Email Address is required.
                </div>
                <div *ngIf="email.errors.email">
                  Please enter correct Email address.
                </div>
              </div>
        </div>
        <div class="breadcumb">
            <span class="active">Contact Details</span>
            <span>>></span>
            <span>Car Details</span>
            <span>>></span>
            <span>Quotes</span>
        </div>
        <div class="insurers">
            <h3>Insurers</h3>
            <div class="text-center">
                <img
                    src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/go-digit-insurance.png" />
            </div>
        </div>
        <div class="form-group">
            <button type="submit" class="btn full-blue-btn" [disabled]="!leadForm.valid">Next</button>
        </div>
    </form>
</div>